// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2h-PP","footer":"ModalFilter_footer__1b4aX"};